import React, { FunctionComponent } from 'react';

import { Link, useParams } from 'react-router-dom';
import HomeSvg from '../../images/svg/Home/cim_home.svg'; // TODO: change to jpg

import './index.scss';

type Props = {
    baseUrl: string;
};

export const HomeLink: FunctionComponent<Props> = ({ baseUrl }) => {
    const { language } = useParams();
    return (
        <Link to={`/${baseUrl}/${language}`} className="home-link">
            <img src={HomeSvg} alt="home" />
        </Link>
    );
};
